import { render, staticRenderFns } from "./Interes.vue?vue&type=template&id=7d2f86d6"
import script from "./Interes.vue?vue&type=script&lang=js"
export * from "./Interes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports